__turbopack_context__.v({
  "loader": "bThysG_loader",
  "spin": "bThysG_spin",
});
